import {
    IPropertyPaneToggleProps
} from '@microsoft/sp-webpart-base';

export class ICustomToggleProps implements IPropertyPaneToggleProps {
    label: string;
    onClick: (value: any) => any;
}